import { FC } from 'react';
import { Rate } from '@base/lib/Rate';
import { IVariant } from 'base/interfaces/product';

type IProdReviewsProps = {
    shownVariant: IVariant;
    onClick?: () => void;
};

export const ProdReviews: FC<IProdReviewsProps> = props => {
    const { shownVariant, onClick } = props;
    const { review } = shownVariant;

    return review ? (
        <Rate
            type={'simple'}
            starSize={22}
            textSize={18}
            value={review.score ? +review.score : 5}
            total={review.reviewNum}
            onClick={() => {
                if (review.reviewNum > 0) {
                    onClick?.();
                }
            }}
        />
    ) : null
};
